import { CircleAlertIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../../../components/ui/accordion";
import type { ScrollSpySection } from "../../stipulations/stipulationCategoryFilters";
import { useScrollSpyRegistrar } from "../scrollSpy/ReviewScrollSpyProvider";

type SectionProperties = {
  title: string;
  defaultOpen?: boolean;
  hasError?: boolean;
  hidden?: boolean;
  /** Stipulations category to filter to while this section is scrolled into view. */
  scrollSpyCategory?: ScrollSpySection;
  children?: React.ReactNode;
};

function Section({ title, defaultOpen = true, hasError, hidden, scrollSpyCategory, children }: SectionProperties) {
  const { t } = useTranslation();
  const registerSection = useScrollSpyRegistrar();
  const value = title.toLowerCase().replaceAll(/\s+/g, "-");
  return (
    <Accordion
      ref={scrollSpyCategory ? registerSection(scrollSpyCategory) : undefined}
      type="single"
      collapsible
      hidden={hidden}
      defaultValue={defaultOpen ? value : undefined}
      className="border-border bg-card shrink-0 overflow-hidden rounded-lg border"
    >
      <AccordionItem value={value} className="border-b-0">
        <AccordionTrigger className="bg-section-header text-foreground px-2 py-2 text-sm font-semibold hover:no-underline lg:px-4">
          <span className="flex-1">{title}</span>
          {hasError && (
            <CircleAlertIcon
              className="size-4 shrink-0 text-amber-500"
              fill="currentColor"
              stroke="var(--color-card)"
              aria-label={t("review.hasErrorLabel")}
              role="img"
            />
          )}
        </AccordionTrigger>
        <AccordionContent className="bg-(--color-background-default-base) text-(--color-text-default-muted) px-(--spacing-2) py-(--spacing-4) text-(length:--typography-base-sizes-extra-small-font-size)/(--typography-base-sizes-extra-small-line-height) lg:px-(--spacing-4) lg:pb-(--spacing-6)">
          {children ?? <p>TODO: implement {title} content.</p>}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}

export default Section;
